import { styled } from '@linaria/react';

import MultipleChoiceQuestion from '@/components/MultipleChoice/MCStandalone';

const code = `
<style>
  .parent {
    width: 200px;
  }
  .box {
    width: 100%;
    border: 2px solid hotpink;
    padding: 20px;
  }
</style>

<div class="parent">
  <div class="box"></div>
</div>
`;

const answers = ['200px', '240px', '244px', '0px'];

const BoxModelQuiz = () => {
  return (
    <Wrapper>
      <MultipleChoiceQuestion
        code={code.trim()}
        codeLang="html"
        answers={answers}
        correctAnswerIndex={2}
      />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  position: relative;
  margin-top: 48px;
  padding-bottom: 32px;
  border-bottom: 1px dashed var(--color-gray-300);
  margin-bottom: 64px;
`;

export default BoxModelQuiz;
